import { connect } from 'react-redux';

import { getDateFilter } from 'ha/pages/Search/selectors';
import DateFilterButton from 'ha/components/Filters/DateFilter/DateFilterButton';

const mapStateToProps = state => ({
  ...getDateFilter(state),
});

export default connect(mapStateToProps)(DateFilterButton);
